export default "__VITE_ASSET__DRTTkCdM__"